import React from "react";
import clsx from "clsx";
import { createPluggable } from "pluggable-react";
import styles from "./GraphNode.module.scss";

export type GraphNodeSectionProps = React.HTMLAttributes<HTMLDivElement> & {
  children?: React.ReactNode;
};

const DefaultGraphNodeHeader = ({ className, ...props }: GraphNodeSectionProps) => (
  <div className={clsx(styles.header, className)} {...props} />
);

const GraphNodeHeader = createPluggable<GraphNodeSectionProps>(
  "deci.graphNode.header",
  DefaultGraphNodeHeader,
);

const DefaultGraphNodeContent = ({ className, ...props }: GraphNodeSectionProps) => (
  <div className={clsx(styles.content, className)} {...props} />
);

const GraphNodeContent = createPluggable<GraphNodeSectionProps>(
  "deci.graphNode.content",
  DefaultGraphNodeContent,
);

const DefaultGraphNodeColLhs = ({ className, ...props }: GraphNodeSectionProps) => (
  <div className={clsx(styles.colLhs, className)} {...props} />
);

const GraphNodeColLhs = createPluggable<GraphNodeSectionProps>(
  "deci.graphNode.colLhs",
  DefaultGraphNodeColLhs,
);

const DefaultGraphNodeColRhs = ({ className, ...props }: GraphNodeSectionProps) => (
  <div className={clsx(styles.colRhs, className)} {...props} />
);

const GraphNodeColRhs = createPluggable<GraphNodeSectionProps>(
  "deci.graphNode.colRhs",
  DefaultGraphNodeColRhs,
);

const DefaultGraphNodeTypeIcon = ({ className, ...props }: GraphNodeSectionProps) => (
  <div className={clsx(styles.typeIcon, className)} {...props} />
);

const GraphNodeTypeIcon = createPluggable<GraphNodeSectionProps>(
  "deci.graphNode.typeIcon",
  DefaultGraphNodeTypeIcon,
);

const DefaultGraphNodeFlag = ({ className, ...props }: GraphNodeSectionProps) => (
  <div className={clsx(styles.entityFlag, className)} {...props} />
);

const GraphNodeFlag = createPluggable<GraphNodeSectionProps>(
  "deci.graphNode.flag",
  DefaultGraphNodeFlag,
);

const DefaultGraphNodeActions = ({ className, ...props }: GraphNodeSectionProps) => (
  <div className={clsx(styles.actions, className)} {...props} />
);

const GraphNodeActions = createPluggable<GraphNodeSectionProps>(
  "deci.graphNode.actions",
  DefaultGraphNodeActions,
);

const DefaultGraphNodeContentBody = ({ className, ...props }: GraphNodeSectionProps) => (
  <div className={clsx(styles.contentBody, className)} {...props} />
);

const GraphNodeContentBody = createPluggable<GraphNodeSectionProps>(
  "deci.graphNode.contentBody",
  DefaultGraphNodeContentBody,
);

export type GraphNodeProps = React.HTMLAttributes<HTMLDivElement> & {
  children?: React.ReactNode;
};

const DefaultGraphNode = ({ className, ...props }: GraphNodeProps) => (
  <div className={clsx(styles.graphNode, className)} {...props} />
);

const GraphNode = createPluggable<GraphNodeProps>("deci.graphNode", DefaultGraphNode);

export default Object.assign(GraphNode, {
  Header: GraphNodeHeader,
  Content: GraphNodeContent,
  ColLhs: GraphNodeColLhs,
  ColRhs: GraphNodeColRhs,
  TypeIcon: GraphNodeTypeIcon,
  Flag: GraphNodeFlag,
  Actions: GraphNodeActions,
  ContentBody: GraphNodeContentBody,
});
